import { Ikon, type IkonNamn } from "../Ikon";
import { RegelchattDemo } from "./RegelchattDemo";

const CHATTPUNKTER: [IkonNamn, string, string][] = [
  ["sign", "Chatten ändrar inga regler själv", "Varje förslag hamnar i styrpanelen och gäller först när en ekonom har godkänt det."],
  ["log", "Effekten syns innan ni godkänner", "Förslaget visar hur många av de senaste 90 dagarnas fakturor som hade fått ett annat förslag."],
  ["shield", "Attestregler kräver två personer", "En ändring i attestflödet ska även godkännas av en andra ekonomiadministratör."],
];

export function Regelchatt() {
  return (
    <section className="s" id="regelchatt">
      <div className="wrap">
        <div className="rcblk">
          <RegelchattDemo />
          <div className="rct">
            <span className="eyebrow">Regelchatt</span>
            <h2 className="h2">Säg vad som ska gälla. Agenten skriver förslaget.</h2>
            <p className="lead">Skriv som till en kollega. Agenten letar upp leverantör och konto, frågar tills regeln är entydig och lägger ett förslag i styrpanelen.</p>
            {CHATTPUNKTER.map(([ikon, h, p]) => (
              <div key={h} className="sitem"><span className="ico"><Ikon namn={ikon} /></span><div><h3>{h}</h3><p>{p}</p></div></div>
            ))}
            <p className="rc-idag">I dag sätter chatten konto, kostnadsställe och fördelningsnycklar. Attestregler via chatten kommer härnäst.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
